/**
 * Phase C — Audio bed registry.
 *
 * Maps style audio keys to optional audio file paths in /public/audio/.
 * If a file is missing or fails to load, CinematicAudio silently no-ops,
 * so the experience degrades gracefully when assets aren't yet shipped.
 *
 * Drop matching MP3 (or OGG) files in /public/audio/ to enable a bed.
 */

import type { RevealStylePreset } from './revealStyles';

export type AudioBedKey = RevealStylePreset['audioBedKey'];

const AUDIO_BEDS: Record<AudioBedKey, string | undefined> = {
  piano_warm: '/audio/reveal/piano-warm.mp3',
  strings_rise: '/audio/reveal/strings-rise.mp3',
  ambient_rain: '/audio/reveal/ambient-rain.mp3',
  heartbeat_low: '/audio/reveal/heartbeat-low.mp3',
  cinematic_air: '/audio/reveal/cinematic-air.mp3',
  paper_room_tone: '/audio/reveal/paper-room-tone.mp3',
};

/** Resolve an audio src for the given bed key. Undefined → silent. */
export function resolveAudioBed(key?: AudioBedKey): string | undefined {
  if (!key) return undefined;
  return AUDIO_BEDS[key];
}
